import Snackbar from 'src/lib/Snackbar'

export const snackbarErrorMessage = (title: string): void => {
  Snackbar.error({title, duration: Snackbar.LENGTH_LONG})
}

export const snackbarInfoMessage = (title: string): void => {
  Snackbar.info({title, duration: Snackbar.LENGTH_LONG})
}
